// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"c9483b04","614":"dd400cee"}[chunkId] + ".chunk.css";
};